import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import PiwikPro from "@piwikpro/react-piwik-pro";
import "./fonts/Montserrat-VariableFont_wght.ttf";

PiwikPro.initialize(
  process.env.REACT_APP_PIWIK_ID,
  "https://urlbuilderonline.piwik.pro"
);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
